// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-5a51d81e],.fade-leave-active[data-v-5a51d81e]{transition:opacity .5s ease}.fade-enter-from[data-v-5a51d81e],.fade-leave-active[data-v-5a51d81e]{opacity:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
